module.exports = __webpack_public_path__ + "static/media/property-managers-3.79f39a12.svg";